import React, { useEffect, useReducer, useState } from 'react';

import { useBroadcastChannel } from '@use-broadcast-channel/hooks';

import { modifiedTokens } from '../designTokens';
import useLocalStorage from '../hooks/useLocalStorage';
import { Context as ReceiveContext } from './context';
import { Reducer, Types } from './reducer';

export const Provider = ({
  children,
  initialState,
  localStorageKey,
}: {
  children: React.ReactNode;
  initialState: any;
  localStorageKey: string;
}) => {
  const [receiveState, setReceiveState] = useLocalStorage(localStorageKey);
  const [, setTheme] = useLocalStorage('custom-theme');
  const initDB = receiveState || {};
  const [focused, setFocused] = useState(false);
  const [state, dispatch] = useReducer(Reducer, { ...initialState, ...initDB });
  const [trigger, setTrigger] = useState(false);
  const { postMessage } = useBroadcastChannel(localStorageKey, (message) => {
    !focused &&
      dispatch({
        type: Types.syncState,
        payload: message,
      });
  });

  const onFocus = () => {
    setFocused(true);
  };

  const onBlur = () => {
    setFocused(false);
  };

  useEffect(() => {
    window.addEventListener('focus', onFocus);
    window.addEventListener('blur', onBlur);

    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('blur', onBlur);
    };
  }, []);

  useEffect(() => {
    setTheme(modifiedTokens);
  }, [setTheme]);

  useEffect(() => {
    const loading = state?.receiveReference?.loading || false;
    const errors = state?.receiveReference?.errors || [];
    !loading && errors?.length === 0 && setReceiveState(state);
    focused && postMessage({ ...state, focused });
    setTrigger(true);
  }, [state, setReceiveState, postMessage, trigger, focused]);

  return <ReceiveContext.Provider value={{ state, dispatch }}>{children}</ReceiveContext.Provider>;
};
